const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:5000'

const auth = {
    namespaced: true,
    state: {
        user: null,
        token: localStorage.getItem('token') || sessionStorage.getItem('token') || null,
        loading: false,
        error: null,
        rememberMe: localStorage.getItem('rememberMe') === 'true'
    },
    mutations: {
        setUser(state, user) {
            state.user = user
        },
        setToken(state, { token, rememberMe }) {
            state.token = token
            state.rememberMe = rememberMe
            
            if (token) {
                if (rememberMe) {
                    localStorage.setItem('token', token)
                    localStorage.setItem('rememberMe', 'true')
                    sessionStorage.removeItem('token')
                } else {
                    sessionStorage.setItem('token', token)
                    localStorage.removeItem('token')
                    localStorage.removeItem('rememberMe')
                }
            } else {
                localStorage.removeItem('token')
                localStorage.removeItem('rememberMe')
                sessionStorage.removeItem('token')
            }
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setError(state, error) {
            state.error = error
        },
        logout(state) {
            state.user = null
            state.token = null
            state.rememberMe = false
            localStorage.removeItem('token')
            localStorage.removeItem('rememberMe')
            sessionStorage.removeItem('token')
        }
    },
    actions: {
        async register({ commit }, { email, password, displayName }) {
            commit('setLoading', true)
            commit('setError', null)
            try {
                const response = await fetch(`${API_URL}/api/auth/register`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ email, password, displayName })
                })
                
                if (!response.ok) {
                    const error = await response.json()
                    throw new Error(error.errors ? error.errors.join(', ') : 'Registration failed')
                }
                
                return await response.json()
            } catch (error) {
                commit('setError', error.message)
                throw error
            } finally {
                commit('setLoading', false)
            }
        },
        async login({ commit, dispatch }, { email, password, rememberMe = true }) {
            commit('setLoading', true)
            commit('setError', null)
            try {
                const response = await fetch(`${API_URL}/api/auth/login`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ email, password })
                })
                
                if (!response.ok) {
                    throw new Error('Invalid email or password')
                }
                
                const data = await response.json()
                commit('setToken', { token: data.token, rememberMe })
                commit('setUser', data.user)
                
                // Fetch liked quotes after login
                dispatch('quotes/fetchLikedQuotes', null, { root: true })
                
                return data
            } catch (error) {
                commit('setError', error.message)
                throw error
            } finally {
                commit('setLoading', false)
            }
        },
        async fetchCurrentUser({ commit, dispatch, state }) {
            if (!state.token) return
            
            try {
                const response = await fetch(`${API_URL}/api/auth/me`, {
                    headers: {
                        'Authorization': `Bearer ${state.token}`
                    }
                })
                
                if (response.ok) {
                    const user = await response.json()
                    commit('setUser', user)
                    
                    // Fetch liked quotes after user is authenticated
                    dispatch('quotes/fetchLikedQuotes', null, { root: true })
                } else {
                    commit('logout')
                }
            } catch (error) {
                console.error('Failed to fetch current user:', error)
                commit('logout')
            }
        },
        logout({ commit }) {
            commit('logout')
            // Clear liked quotes on logout
            commit('quotes/setLikedQuotes', [], { root: true })
        }
    },
    getters: {
        isAuthenticated: (state) => !!state.token,
        currentUser: (state) => state.user
    }
}

export default auth
